import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const IntegrationSettingsSection = ({ data, onChange, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [localData, setLocalData] = useState(data);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setLocalData(data);
    setIsEditing(false);
    setIsSaving(false);
  }, [data]);

  const handleChange = (field, value) => {
    setLocalData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    await onSave(localData);
    setIsSaving(false);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setLocalData(data);
    setIsEditing(false);
  };

  const testKakaoConnection = () => {
    alert('카카오톡 연동 테스트가 성공적으로 완료되었습니다.');
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 lg:p-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-error/10 rounded-md flex items-center justify-center">
            <Icon name="Plug" size={20} color="var(--color-error)" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
              연동 설정
            </h2>
            <p className="text-sm caption text-muted-foreground">
              외부 서비스와의 연동을 관리합니다
            </p>
          </div>
        </div>
        
        {!isEditing && (
          <Button
            variant="outline"
            size="default"
            iconName="Edit"
            iconPosition="left"
            onClick={() => setIsEditing(true)}
          >
            수정
          </Button>
        )}
      </div>
      <div className="space-y-6">
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-[#FEE500] rounded-md flex items-center justify-center">
                <Icon name="MessageCircle" size={24} color="#000000" />
              </div>
              <div>
                <h3 className="text-lg font-heading font-semibold text-foreground">
                  카카오톡 연동
                </h3>
                <p className="text-sm caption text-muted-foreground">
                  세션 알림을 카카오톡으로 발송합니다
                </p>
              </div>
            </div>
            <div className={`
              px-3 py-1.5 rounded-md text-sm font-medium
              ${localData?.kakaoEnabled 
                ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
              }
            `}>
              {localData?.kakaoEnabled ? '연동됨' : '미연동'}
            </div>
          </div>

          <Checkbox
            label="카카오톡 알림 활성화"
            description="세션 관련 알림을 카카오톡으로 발송합니다"
            checked={localData?.kakaoEnabled}
            onChange={(e) => handleChange('kakaoEnabled', e?.target?.checked)}
            disabled={!isEditing}
          />

          {localData?.kakaoEnabled && (
            <div className="ml-8 space-y-4">
              <Input
                label="API 키"
                type="password"
                placeholder="카카오톡 API 키를 입력하세요"
                value={localData?.kakaoApiKey}
                onChange={(e) => handleChange('kakaoApiKey', e?.target?.value)}
                disabled={!isEditing}
                required
              />
              
              <Input
                label="발신자 프로필 키"
                type="text"
                placeholder="발신자 프로필 키를 입력하세요"
                value={localData?.kakaoSenderKey}
                onChange={(e) => handleChange('kakaoSenderKey', e?.target?.value)}
                disabled={!isEditing}
                required
              />

              {!isEditing && (
                <Button
                  variant="outline"
                  iconName="Zap"
                  iconPosition="left"
                  onClick={testKakaoConnection}
                >
                  연동 테스트
                </Button>
              )}
            </div>
          )}
        </div>

        <div className="bg-muted rounded-md p-4">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} className="text-muted-foreground mt-0.5" />
            <div className="flex-1">
              <h4 className="text-sm font-medium text-foreground mb-1">
                연동 안내
              </h4>
              <p className="text-sm caption text-muted-foreground">
                외부 서비스 연동을 위해서는 해당 서비스의 API 키가 필요합니다.\n각 서비스의 개발자 콘솔에서 API 키를 발급받으실 수 있습니다.
              </p>
            </div>
          </div>
        </div>

        {isEditing && (
          <div className="flex gap-3 pt-4 border-t border-border">
            <Button
              variant="outline"
              onClick={handleCancel}
              disabled={isSaving}
              fullWidth
            >
              취소
            </Button>
            <Button
              variant="default"
              onClick={handleSave}
              loading={isSaving}
              iconName="Save"
              iconPosition="left"
              fullWidth
            >
              저장
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default IntegrationSettingsSection;